import { render, staticRenderFns } from "./azureFile.vue?vue&type=template&id=4187d259&"
import script from "./azureFile.vue?vue&type=script&lang=js&"
export * from "./azureFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports